import { createUseStyles } from "react-jss";

export const useCompareDropdownStyles = createUseStyles({
  optionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // borderTop: "1px solid var(--border-color)",
    // borderBottom: "1px solid var(--border-color)",
    // padding: "8px",
    width: "100%",
    boxSizing: "border-box",
    "& > *": {
      width: "100%",
    },
    "& label": {
      width: "100%",
    },
  },
  mySelectable: {
    "& .euiPopoverTitle": {
      padding: 0,
    },
    "& .wis-wis0e4-euiPopoverTitle-none-s": {
      "border-block-end": "1px solid var(--border-color)!important",
    },
  },
  hideEuiCheckmarks: {
    "& .euiSelectableListItem__iconCheck": {
      display: "none !important",
    },
    "& .euiSelectableListItem__content--selected::after": {
      display: "none !important",
    },
    "& .euiSelectableListItem__prepend": {
      display: "none !important",
    },
    "& .euiSelectableListItem__append": {
      display: "none !important",
    },
    "& .euiFieldSearch": {
      height: "38px",
      boxShadow: "none",
      borderRadius: "6px 6px 0 0",
    },
    "& .euiFieldSearch--compressed": {
      boxShadow: "none",
    },
  },
  checkboxLabel: {
    display: "grid",
    gridTemplateColumns: "6.5fr 3.5fr",
    width: "100%",
  },
  overrideTruncation: {
    "& .euiSelectableListItem__text.euiSelectableListItem__text--truncate": {
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
      display: "block",
      width: "100%",
      flex: 1,
    },
  },
});
